import "./App.css";
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import Footer from "./components/Layout/Footer";
import Landing from "./components/Home/Landing";
// import Journey from "./components/Journey/Journey";
import Carrer from "./components/Carrer/Carrer";
// import Team from "./components/Team/Team";
import Resources from "./components/Resources/Resources";
import Sustainability from "./components/Sustainability/Sustainability";
import Esg from "./components/Esg/Esg";
import Approach from "./components/IntegratedApproach/Approach";
import Climate from "./components/Climate/Climate";
import PartnerShip from "./components/PartnerShip/PartnerShip";
import Contact from "./components/Contact/Contact";
import Blogs from "./components/Blogs/Blogs";
import BlogDetail from "./components/Blogs/BlogDetail";
import { useState, useRef, useEffect } from "react";
import scrollToSentence from "./components/scrolltoPosition";
import Certification from "./components/certification/Certification";
import Vajra from "./components/Vajra/Vajra";
import MyKarb from "./components/myKarb/myKarb";
import Cbam from "./components/cbam/cbam";
import { ModalProvider, useModal } from "./contexts/ModalContext";
import DemoModal from "./components/DemoModal";
import NewHeader from "./components/Layout/NewHeader";
import Solutions from "./components/solutions/Solutions";
import ESGTrainingView from "./components/Home/ESG/ESGTrainingView";
import PdfViewer from "./components/PpdfViewer";
import AboutView from "./components/Home/About/AboutView";
import OurTeamView from "./components/Home/OurTeam/OurTeamView";
import EventAndGallery from "./components/Home/EventAndGallery/EventAndGallery";
import Whitepaper from "./components/Whitepaper/Whitepaper";
import CaseStudies from "./components/CaseStudies/CaseStudies";
import NotFound from "./components/NotFound";

function highlightWord(word) {
  function traverseAndHighlight(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue;
      const regex = new RegExp(`\\b(${word})\\b`, "gi");
      if (regex.test(text)) {
        const highlightedText = text.replace(
          regex,
          '<span class="highlight">$1</span>'
        );
        const span = document.createElement("span");
        span.innerHTML = highlightedText;
        node.parentNode.replaceChild(span, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(traverseAndHighlight);
    }
  }

  traverseAndHighlight(document.body);
}

// Global Modal Component
function GlobalModal() {
  const { isModalOpen, closeModal } = useModal();

  return <DemoModal open={isModalOpen} onClose={closeModal} />;
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const searchVal = searchParams.get("search") || "";
  const [visible, setVisible] = useState(true);

  // Global redirect to ensure no URLs end with a hyphen
  useEffect(() => {
    if (location.pathname.endsWith('-')) {
      const cleanPath = location.pathname.replace(/-+$/, '');
      navigate(cleanPath + location.search + location.hash, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);
  useEffect(() => {
    if (searchVal) {
      highlightWord(searchVal);
      scrollToSentence(searchVal);
    }
  }, [searchVal]);
  const prevScrollY = useRef(0);
  const bodyRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Always show navbar when near the top of the page
      if (currentScrollY < 100) {
        setVisible(true);
      }
      // Determine scroll direction for the rest
      else if (currentScrollY < prevScrollY.current) {
        // Scrolling up - show navbar
        setVisible(true);
      } else if (currentScrollY > prevScrollY.current) {
        // Scrolling down - hide navbar
        setVisible(false);
      }

      // Update prevScrollY with current scroll position
      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const excludeHederFooter = [
    "/vajra-brochure",
    "/maykarb-brochure",
    "/nirantara-brochure",
  ];
  const locationUrl = useLocation().pathname;

  const addStylingToBody = () => {
    document.body.style.zoom = "100%";
  };

  useEffect(() => {
    if (excludeHederFooter.includes(locationUrl)) {
      addStylingToBody();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [locationUrl]);

  return (
    <ModalProvider>
      <div
        className={`${excludeHederFooter.includes(locationUrl)
          ? null
          : "w-full flex flex-col"
          }  ${window.location.pathname === "/" && "h-screen  bg-neutral-800"}`}
      >
        {/* <Header visible={visible} /> */}
        {!excludeHederFooter.includes(locationUrl) ? <NewHeader /> : null}
        <div>
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Landing />} />
            {/* <Route path="/products" element={<Products />} /> */}
            {/* <Route path="/journey" element={<Journey />} /> */}
            <Route path="/career" element={<Carrer />} />
            <Route path="/about-us" element={<AboutView />} />
            <Route path="/our-team" element={<OurTeamView />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/certification" element={<Certification />} />
            <Route path="/sustainability" element={<Navigate to="/" replace />} />
            <Route path="/event-gallery" element={<EventAndGallery />} />
            <Route path="/integrated-approach" element={<Navigate to="/solutions" replace />} />
            <Route
              path="/membership-and-partnership"
              element={<PartnerShip />}
            />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/vajra" element={<Vajra />} />
            <Route path="/myKarb" element={<MyKarb />} />
            <Route path="/cbam" element={<Cbam />} />
            <Route path="/solutions" element={<Solutions />} />
            {/* Retired ESG Advisory pages -> Training */}
            <Route
              path="/esg-advisory"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/esg"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/climate-and-esg"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/strategy-development"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/reporting-and-compliance"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/due-diligence-and-compliance"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/environmental-and-climate-consulting"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/governance-and-board-advisory"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/social-impact-and-csr-advisory"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/sustainable-supply-chain"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/circular-economy"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/sustainable-finance"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/full-implementation-and-project-delivery"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/esg-training-apliance"
              element={<Navigate to="/esg-trainings" replace />}
            />
            <Route
              path="/vajra-brochure"
              element={<PdfViewer fileUrl="/assets/vajra.pdf" />}
            />
            <Route
              path="/mykarb-brochure"
              element={<PdfViewer fileUrl="/assets/maykarb.pdf" />}
            />
            <Route
              path="/nirantara-brochure"
              element={<PdfViewer fileUrl="/assets/nirantara.pdf" />}
            />
            <Route path="/esg-trainings" element={<ESGTrainingView />} />
            <Route path="/whitepaper" element={<Whitepaper />} />
            <Route path="/case-studies" element={<CaseStudies />} />
          </Routes>
        </div>
        {!excludeHederFooter.includes(locationUrl) ? <Footer /> : null}
        <GlobalModal />
      </div>
    </ModalProvider>
  );
}

export default App;
